/**
 * "Reassigned from <name>" — the one place that renders an article's original
 * author (#488).
 *
 * `originalAuthor` is admin-only and null for the overwhelming majority of
 * articles, which never change hands, so this renders nothing on the common
 * path. Non-null means "not with its original author right now" — which is
 * exactly what the reader needs told, and why the copy is past tense.
 *
 * The controller already resolves name-or-email into `name`, so there is no
 * fallback to repeat here.
 */
export default function ReassignedFrom({ originalAuthor, as: Tag = "p", className = "" }) {
  if (!originalAuthor) return null

  return (
    <Tag className={`text-xs text-amber-700 mt-0.5 ${className}`.trim()}>
      Reassigned from {originalAuthor.name}
    </Tag>
  )
}
